<div class="row">
    <div class="col-12">

        <div class="card">

            <!-- <div class="card-header">
                <div class="title">{{ 'PRODUCT.UPLOAD_DATA' | translate }}</div>
                <div class="tools">

                </div>
            </div> -->
           
            <div class="card-body">

                <form class="form" #f="ngForm" [formGroup]="form" autocomplete="off">

                    <div class="row type-upload">

                        <div class="col-10 type-upload_input">

                            <div class="form-group">
                                <label class="filter-label"> {{ 'PRODUCT.DATA_TYPE_TO_UPLOAD' | translate }}
                                </label>
                                <svg-icon tooltipClass="clue-name" ngbTooltip="Обязательное для заполнения" src="/assets/images/icons/info-circle.svg" [stretch]="true"
                                [svgStyle]="{'width.px':15, 'height.px':15, 'margin-left.px':6}"></svg-icon>
                                <ng-select 
                                class="custom" 
                                clearAllText="{{ 'CLEAR' | translate }}"
                                notFoundText="{{ 'NO_DATA' | translate }}" 
                                bindLabel="name" 
                                placeholder="{{ 'Выберите из списка' | translate }}"
                                bindValue="type"
                                formControlName="type" 
                                [multiple]="false" 
                                [items]="download_types">
                                </ng-select>
                                <!-- <div *ngIf="errorMessages">
                                    <div *ngFor="let item of errorMessages.type">
                                        <div class="text-error" *ngIf="validation('type', item.type)">
                                            {{ item.message | translate: item.options }}
                                        </div>
                                    </div>
                                </div> -->
                            </div>
                        </div>

                        <div class="col-2 type-upload_btn">
                            <button type="button" class="btn btn-primary upload-btn  btn-create" (click)="onDownload()" [disabled]="form.invalid"> {{ 'UPLOAD' | translate }}</button>
                        </div>

                    </div>

                    <div class="card" style="margin-top: 0 !important;" *ngIf="form.get('type').value == 'mediaFiles' || form.get('type').value == 'all'" style="margin-top: 10px;">
                        <div class="card-body">
                        <div class="row">

                            <div class="col-12" style="margin-top: 40px; margin-bottom: 30px;">
                                <span class="attr-title">{{ 'PRODUCT.SETTING_FOR_UPLOADING_MIDEA_FILES' | translate }}</span>
                            </div>

                            <div class="col-4">
                                
                                <div class="form-group">
                                    <label class="filter-label"> {{ 'PRODUCT.MEDIA_FILE_EXTENSIONS' | translate }}</label>
                                    <svg-icon tooltipClass="clue-name" ngbTooltip="Обязательное для заполнения" src="/assets/images/icons/info-circle.svg" [stretch]="true"
                                    [svgStyle]="{'width.px':15, 'height.px':15, 'margin-left.px':6}"></svg-icon>
                                    <ng-select 
                                    id="format"
                                    class="custom" 
                                    clearAllText="{{ 'CLEAR' | translate }}"
                                    notFoundText="{{ 'NO_DATA' | translate }}"
                                    placeholder="{{ 'Выберите из списка' | translate }}" 
                                    bindLabel="name" 
                                    bindValue="id"
                                    formControlName="media_format"
                                    [items]="media_file_extensions">
                                    </ng-select>
                                    <div *ngIf="errorMessages">
                                        <div *ngFor="let item of errorMessages.media_format">
                                            <div class="text-error" *ngIf="validation('media_format', item.type)">
                                                {{ item.message | translate: item.options }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-4">

                                <div class="form-group">
                                    <label class="filter-label"> {{ 'PRODUCT.GROUP_TYPE' | translate }}</label> 
                                    <svg-icon tooltipClass="clue-name" ngbTooltip="Обязательное для заполнения" src="/assets/images/icons/info-circle.svg" [stretch]="true"
                                    [svgStyle]="{'width.px':15, 'height.px':15, 'margin-left.px':6}"></svg-icon>
                                    <ng-select 
                                    class="custom" 
                                    clearAllText="{{ 'CLEAR' | translate }}"
                                    notFoundText="{{ 'NO_DATA' | translate }}" 
                                    placeholder="{{ 'Выберите из списка' | translate }}" 
                                    bindLabel="name" 
                                    bindValue="id"
                                    formControlName="group_by" 
                                    [multiple]="false" 
                                    [items]="group_by">
                                    </ng-select>
                                    <div *ngIf="errorMessages">
                                        <div *ngFor="let item of errorMessages.group_by">
                                            <div class="text-error" *ngIf="validation('group_by', item.type)">
                                                {{ item.message | translate: item.options }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-4">
                                    
                                <div class="form-group">
                                    <label class="filter-label"> {{ 'Список атрибутов наименования файла' | translate }}</label>
                                    <ng-select 
                                    class="custom" 
                                    clearAllText="{{ 'CLEAR' | translate }}"
                                    notFoundText="{{ 'NO_DATA' | translate }}" 
                                    placeholder="{{ 'Выберите из списка' | translate }}" 
                                    bindLabel="attribute_name" 
                                    bindValue="attribute_id"
                                    formControlName="attribute_for_naming_images" 
                                    [multiple]="false" 
                                    [items]="textAttributes">
                                    </ng-select>
                                </div>

                            </div>

                            <div class="col-6 attrs-title-block">{{ 'PRODUCT.ALL_MEDIA_ATTRIBUTES' | translate }} </div>
                            <div class="col-6 attrs-title-block second">{{ 'PRODUCT.MY_MEDIA_ATTRIBUTES' | translate }} </div>
                            <!-- <div class="col-12">
                                <div class="col-6 attrs-filter">
                                    <form class="form" [formGroup]="searchForm" autocomplete="off">
                
                                        <input formControlName="searchMedia" class="form-control" type="text" placeholder="{{ 'SEARCH' | translate }}" aria-label="Search">
                                        
                                    </form>
                                </div>
                            </div> -->
                           
                            <div class="col-12 attrs-block">

                                <div class="col-6 card attr-card">

                                    <div class="container search-input">
                                        <div class="attrs-filter">
                                            <form class="form" [formGroup]="searchForm" autocomplete="off">

                                                <svg-icon class="search-icon" src="/assets/images/icons/closed-page-layout/search.svg" [stretch]="true"
                                                [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                        
                                                <input formControlName="searchMedia" class="form-control list-group-item" type="text" placeholder="{{ 'SEARCH' | translate }}" aria-label="Search">
                                                
                                            </form>
                                        </div>
                                    </div>
                                
                                    <div class="container search" dragula="MEDIA_ATTRIBUTES" [(dragulaModel)]="mediaAttributes">

                                        <li *ngFor="let item of mediaAttributes" class="list-group-item">
                                            <span>{{item.name}}</span>
                                            <svg-icon src="/assets/images/icons/drag.svg" [stretch]="true"
                                            [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                                            
                                        </li>
                                    </div>
                                </div>

                                <div class="col-6 card myAttrCard">
                                    
                                    <div class="container" dragula="MEDIA_ATTRIBUTES" [(dragulaModel)]="myMediaAttributes">
                                        <li *ngFor="let item of myMediaAttributes" class="list-group-item">
                                            <span>{{item.name}}</span>
                                            <svg-icon src="/assets/images/icons/drag.svg" [stretch]="true"
                                            [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                                        </li>
                                    </div>
                                    
                                </div>

                            </div>

                            <div class="col-12 filter-label" style="margin-top: 25px; margin-bottom: 8px;">
                                <span> {{ 'SIZES' | translate }}</span>
                            </div>
                            
                            <div class="col-12" style="margin-bottom: 25px;">
                                <div class="check-all-attributes-action_tools pointer">
                                    <div class="custom-control custom-checkbox">
                                        <input class="custom-control-input"
                                        name="is_default" 
                                        id="is_default" 
                                        type="checkbox"
                                        (change)="is_default = !is_default"> 
                                        <label 
                                        class="custom-control-label" 
                                        for="is_default">
                                            {{ 'по умолчанию' | translate }}
                                        </label>
                                    </div>
                                </div>
                                <!-- <div class="form-group checkbox">
                                    <input class="form-check-input" 
                                    type="checkbox" 
                                    [checked]="is_default"
                                    (change)="is_default = !is_default">
                                    <label class="form-check-label"> {{ 'по умолчанию' | translate }}</label>
                                </div> -->
                            </div>
                               
                            <div class="col-4" *ngIf="!is_default">
                                <div class="form-group">
                                    <label for="width" class="label"> {{ 'WIDTH' | translate }}</label>
                                    <input type="text" class="form-control" id="width" placeholder="{{ 'Введите значения' | translate }}"   formControlName="width">
                                </div>
                            </div>

                            <div class="col-4" *ngIf="!is_default">
                                <div class="form-group">
                                    <label for="height" class="label"> {{ 'HEIGHT' | translate }}</label>
                                    <input type="text" class="form-control" id="height" placeholder="{{ 'Введите значения' | translate }}"   formControlName="height">
                                </div>
                            </div>

                        </div>

                        </div>
                    </div>
                    <div class="card"  style="margin-top: 0 !important;" *ngIf="form.get('type').value == 'textFiles' || form.get('type').value == 'all'" style="margin-top: 10px;">
                        <div class="card-body">
                            <div class="row">

                                <div class="col-12" style="margin-top: 40px; margin-bottom: 30px;">
                                    <span>{{ 'PRODUCT.SETTING_FOR_UPLOADING_TEXT_FILES' | translate }}</span>
                                </div>

                                <div class="col-4">
                                    
                                    <div class="form-group">
                                        <label class="filter-label"> {{ 'FILE_EXTENSION' | translate }}</label>
                                        <svg-icon tooltipClass="clue-name" ngbTooltip="Обязательное для заполнения" src="/assets/images/icons/info-circle.svg" [stretch]="true"
                                        [svgStyle]="{'width.px':15, 'height.px':15, 'margin-left.px':6}"></svg-icon>
                                        <ng-select 
                                        id="format"
                                        class="custom" 
                                        clearAllText="{{ 'CLEAR' | translate }}"
                                        notFoundText="{{ 'NO_DATA' | translate }}"
                                        placeholder="{{ 'Выберите из списка' | translate }}"  
                                        bindLabel="name" 
                                        bindValue="id"
                                        formControlName="text_format" 
                                        [items]="file_extensions">
                                        </ng-select>
                                        <div *ngIf="errorMessages">
                                            <div *ngFor="let item of errorMessages.text_format">
                                                <div class="text-error" *ngIf="validation('text_format', item.type)">
                                                    {{ item.message | translate: item.options }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-8"></div>

                                <div class="col-6 attrs-title-block">{{ 'ALL_ATTRIBUTES' | translate }} </div>
                                <div class="col-6 attrs-title-block second">{{ 'MY_ALLTRIBUTES' | translate }} </div>
                                <!-- <div class="col-12">
                                    <div class="col-6 attrs-filter">
                                        <form class="form" [formGroup]="searchForm" autocomplete="off">
                    
                                            <input formControlName="search" class="form-control" type="text" placeholder="Поиск" aria-label="Search">
                                            
                                        </form>
                                    </div>
                                </div> -->
                                <div class="col-12 attrs-block">
    
                                    <div class="col-6 card attr-card">

                                        <div class="container search-input">

                                            <div class="attrs-filter">
                                                <form class="form" [formGroup]="searchForm" autocomplete="off">

                                                    <svg-icon class="search-icon" src="/assets/images/icons/closed-page-layout/search.svg" [stretch]="true"
                                                    [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                            
                                                    <input formControlName="search" class="form-control list-group-item" type="text" placeholder="Поиск" aria-label="Search">
                                                    
                                                </form>
                                            </div>


                                        </div>
          
                                        <div class="container search" dragula="ATTRIBUTES_LIST" [(dragulaModel)]="textAttributes">

                                            <li *ngFor="let item of textAttributes" class="list-group-item">
                                                <span>{{item.attribute_name}}</span>
                                                <svg-icon src="/assets/images/icons/drag.svg" [stretch]="true"
                                                [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                                            </li>
                                        </div>
                                    </div>
    
                                    <div class="col-6 card">
                                        
                                        <div class="container" dragula="ATTRIBUTES_LIST" [(dragulaModel)]="myAttributes">
                                            <li *ngFor="let item of myAttributes; let i = index" class="list-group-item">
                                                <!-- {{item.order_num}}: {{item.attribute_name}} -->
                                                <span>{{item.attribute_name}}</span>
                                                <svg-icon src="/assets/images/icons/drag.svg" [stretch]="true"
                                                [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                                            </li>
                                        </div>
                                        
                                    </div>
    
                                </div>

                            </div>
                        </div>
                    </div>    
                </form>

            </div>
        </div>
    </div>
</div>